export default __webpack_public_path__ + "static/media/volunteer1white.78ca26f3.png";